export default __webpack_public_path__ + "46ffe7a0736a886dde2dc74ddd11ac12.png";